import moment from "moment"
import PropTypes from "prop-types"
import React from "react"

import {useTranslation} from "react-i18next"
import {DownloadButton} from "~/components/"

const icon = require("~/icons/document_32_blue.svg")

const ListItemDocument = props => {
  const {t} = useTranslation()
  const attachedAtHuman = t("timestamp", {
    timestamp: moment(`${props.attached_at}`).format("DD.MM.YYYY, HH:mm")
  })

  return (
    <div className="sh-list-item">
      <img src={icon} alt={"Area"} />
      <div className={"content"}>
        <DownloadButton
          label={props.title}
          endpoint={props.file_url}
          filename={`${props.title}.${props.extension}`}
          mimeType={props.mime_type}
        />
        <div className="secondary">
          {t("articles.detail.attachedAt", {attachedAt: attachedAtHuman})}
        </div>
      </div>
    </div>
  )
}

ListItemDocument.propTypes = {
  attached_at: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  file_url: PropTypes.string.isRequired
}

export default ListItemDocument



// WEBPACK FOOTER //
// ./src/components/list_items/ListItemDocument.js